export enum NotificationTag {
    silent = 'silent',
    broker_silent = 'broker_silent',
    carrier_silent = 'carrier_silent',
    drayage = 'drayage',
    extracharge = 'extracharge',
    blockchain = 'blockchain',
    drayageUpdate = 'drayageUpdate',
    loadLocationUpdate = 'loadLocationUpdate',
    csvUpdate = 'csvUpdate',
}
